export const leftMouseClick = 1;

export const middleMouseClick = 4;

export const ADJUSTED_X_AXIS = -5;

export const SHARED_TOOLTIP_VARIANT = 'shared';

export const DISPLAY_UNITS_LIMIT = 3;
